import React from 'react'

import withDefaults from 'src/utils/with-defaults'

interface Props {
  className?: string
}

const defaultProps = {
  className: '',
}

type NativeAttrs = Omit<React.HTMLAttributes<HTMLHeadingElement>, keyof Props>
export type FieldsetSubtitleProps = Props & typeof defaultProps & NativeAttrs

const FieldsetSubtitle: React.FC<FieldsetSubtitleProps> = ({ className, children, ...props }) => {
  return (
    <>
      <p className={className} {...props}>
        {children}
      </p>
      <style jsx>{`
        p {
          font-size: 0.875rem;
          line-height: 1.6;
        }
      `}</style>
    </>
  )
}

const MemoFieldsetSubtitle = React.memo(FieldsetSubtitle)

export default withDefaults(MemoFieldsetSubtitle, defaultProps)
